module.exports = __webpack_public_path__ + "img/works_trueEtn_btm_off.0745d896.jpg";